import { useEffect } from 'react';
import { useImageStore } from '@/entities/image/store';

const ICONS: Record<string, string> = {
  info: 'ℹ️',
  success: '✅',
  warning: '⚠️',
  error: '❌',
};

function NotificationItem({ n, index }: { n: { type: string; message: string }; index: number }) {
  const clearNotification = useImageStore((s) => s.clearNotification);

  useEffect(() => {
    const timer = setTimeout(() => {
      clearNotification(index);
    }, 5000);
    return () => clearTimeout(timer);
  }, [clearNotification, index]);

  return (
    <div
      className={`px-4 py-2 rounded-lg shadow-lg text-sm max-w-xs flex items-center gap-2 bg-gray-800 border border-gray-600 animate-slide-in cursor-pointer hover:bg-gray-700`}
      onClick={() => clearNotification(index)}
    >
      <span>{ICONS[n.type] || '•'}</span>
      <span className="flex-1">{n.message}</span>
    </div>
  );
}

export default function Notifications() {
  const notifications = useImageStore((s) => s.notifications);

  return (
    <div className="fixed bottom-4 right-4 flex flex-col gap-2 z-50">
      {notifications.map((n, i) => (
        <NotificationItem key={`${i}-${n.message}`} n={n} index={i} />
      ))}
    </div>
  );
}
